module.exports = __webpack_public_path__ + "4acb111ac544656aa4c00e39856597c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/disdiscount.png
// module id = 702
// module chunks = 0